import React from "react";

const CustomLoader = () => {
  return (
    <>
      <style>
        {`
          .bouncing-loader {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 8px;
          }

          .dot {
            width: 16px;
            height: 16px;
            border-radius: 50%;
            animation: bounce 0.6s infinite alternate;
          }

          .dot1 {
            background-color: #0196bf;
            animation-delay: 0s;
          }

          .dot2 {
            background-color: #e50c33;
            animation-delay: 0.2s;
          }

          .dot3 {
            background-color: #fda800;
            animation-delay: 0.4s;
          }

          @keyframes bounce {
            to {
              transform: translateY(-20px);
            }
          }
        `}
      </style>
      <div className="bouncing-loader">
        <div className="dot dot1"></div>
        <div className="dot dot2"></div>
        <div className="dot dot3"></div>
      </div>
    </>
  );
};

export default CustomLoader;
